import React from 'react'

export const Loading = () => {
  return (
    <div className="spinner">
      <img src={require('../assets/images/loading.svg')} alt="loading"/>
    </div>
  )
}